import Concept from './Concept'
import Business from './Business'
import Company from './Company'
import Contact from './Contact'

export default {
  pcConcept: Concept,
  pcBusiness: Business,
  pcCompany: Company,
  pcContact: Contact
}
